import React, { Fragment, useContext, useEffect } from "react";
import { Route, Switch, withRouter } from "react-router";
import  Layout  from "./shared/layout";
import Home from "./components/home/home";
import { SearchView } from "./components/search/search.view";
import Login from "./components/login/login";
import { ToastContainer } from "react-toastify";
import PrivateRoute from "./shared/privateRoute";
import { observer } from "mobx-react";
import {RootStoreContext} from './core/store/rootStore';
import UserAdministration from './components/user/user.administration';
import ModalContainer from './core/common/modal.container';
import "./app.css";
import {history} from "./index";
import Role from "./shared/enums/roleEnum";
import CompaniesAdministration from "./components/companies/companies.administration";
import ForgotPassword from "./components/login/forgotpassword";
import LogsList from "./components/logs/logs.list";

const App = () => {

  const rootStore = useContext(RootStoreContext);
  const { setAppLoaded, token, appLoaded } = rootStore.commonStore;
  const { getUser, getRole } = rootStore.userStore;

    useEffect(() => {
    if (token) {
      getUser().then((result) => {
          let role = getRole;
          if (role != null && window.location.pathname === "/") {
              if (role === Role.ADMIN)
                  history.push("/administration");
              else if (role === Role.SUPER_ADMIN)
                  history.push("/companies");
              else
                  history.push("/home");
          }

          setAppLoaded();
      });
    } else {
      setAppLoaded();
      let href = window.location.href;
      if (href.indexOf("recover-password") === -1)
          history.push("/login");
    }
  }, [getUser, setAppLoaded, token, getRole ]);

  if (!appLoaded) return (<div className="center-this">Chargement du site...</div>);

  return (
    <Fragment>
      <ModalContainer />
      <ToastContainer position="top-right" />
      <Route path="/login" component={Login} />
      <Route path="/recover-password/:recoveryGuid" component={ForgotPassword} />
      <Switch>
        <Layout>
          <PrivateRoute path="/home" component={Home} />
          <PrivateRoute path="/search" component={SearchView} />
          <PrivateRoute path="/companies" component={CompaniesAdministration} />
          <PrivateRoute path="/administration" component={UserAdministration} />
          <PrivateRoute path="/logs" component={LogsList} />
        </Layout>
      </Switch>
    </Fragment>
  );
};

export default withRouter(observer(App));
